import alt from '../alt';
import Immutable from 'seamless-immutable';
import {seamlessImmutable, seamlessBootstrap} from 'epic-alt-utils/index';

@seamlessImmutable
class HomeStore {
    constructor() {
        this.on('error', (error) => {console.error(error);});
        this.on('bootstrap', seamlessBootstrap.bind(this, null));
        this.state = Immutable({
            header: null,
            trailer: null,
            story: null,
            gameplay: null,
            screenshots: [],
            facebookLink: null,
            twitterLink: null,
            youtubeLink: null,
            reactions: null,
            mods: null,
            modsEnabled: false
        });
    }
}

export default alt.createStore(HomeStore, 'HomeStore');
